:host {
  display: block;
}

.avatar-wrapper {
  box-sizing: border-box;
  -moz-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.avatar {
  background: var(--color-steel-100);
  border-radius: 100%;
  width: 48px;
  height: 48px;
  left: 0px;
  top: 0px;
  line-height: 26px;
  justify-content: center;
  align-items: center;
  display: inline-flex;

  &:hover:not(.no-states) {
    background: var(--color-steel-200);
    cursor: pointer;
  }

  &:active:not(.no-states) {
    background: var(--avatar-background-color);
    color: var(--avatar-text-color) !important;
  }

  &.size-small {
    width: 32px;
    height: 32px;
    line-height: 20px;
  }

  &.background-transparent {
    background-color: transparent;

    &:hover {
      background-color: transparent;
      color: var(--color-steel-600) !important;
    }
  }

  &.avatar-label {
    margin: auto;
    @apply font-text-bold;
    font-size: var(--copytext-font-size);
    color: var(--color-black);
    letter-spacing: var(--letter-spacing-basic);

    &.size-small {
      font-size: var(--copytext-font-size-smaller);
    }
  }

  &.logged-out {
    span {
      @apply text-[24px];

      @media (min-width: theme('screens.md')) {
        @apply text-[32px];
      }

      @media (min-width: theme('screens.lg')) {
        @apply text-[24px];
      }
    }
  }
}
